  import { Injectable } from "@angular/core";
import { Status } from "./models/status.model";



@Injectable()
export class TransactionStatus{
  constructor(){
    
  }
  getListTransactionStatus():Status[]{
    let typeList:Status[]=[];
    typeList.push( new Status(0, 'Thất bại'));
    typeList.push( new Status(1, 'Mới'));
    typeList.push( new Status(2, 'Đang xử lý'));
    typeList.push( new Status(3, 'Thành công'));
    typeList.push( new Status(4, 'Không rõ'));
    return typeList;
  }
}